import { render, staticRenderFns } from "./LogoGallery.vue?vue&type=template&id=21273228&scoped=true"
import script from "./LogoGallery.vue?vue&type=script&lang=js"
export * from "./LogoGallery.vue?vue&type=script&lang=js"
import style0 from "./LogoGallery.vue?vue&type=style&index=0&id=21273228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21273228",
  null
  
)

export default component.exports